module.exports = __webpack_public_path__ + "img/avatar10_11zon.c8bae863.webp";